<template>
  <v-dialog
    v-model="show"
    width="350"
    persistent
    @keydown.esc="closeModal"
  >
    <v-card elevation="0">
      <v-card-title class="app-card-title">
        <span>Confirmar Exclusão</span>
      </v-card-title>
      <v-card-text class="app-card-content pb-0">        
        <p class="mb-7">  
          Tem certeza de que deseja desvincular a funcionalidade 
          <strong>{{ item.functionality.name }}</strong> deste perfil?
        </p>

        <span class="app-form__warning">
          Atenção: Após confirmar, esta ação <em>não poderá</em> ser desfeita!
        </span>
      </v-card-text>  
      <v-divider />
      <v-card-actions>
        <v-spacer />       
        <v-btn
          text
          color="error"
          @click="closeModal"
        >
          Cancelar
        </v-btn>
        <v-btn
          text
          color="success"
          @click="deleteFunctionality"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import PerfisService from '@/services/perfis.service';

  export default {
    name: 'ProfileFunctionalityList',

    props: {
      item: {
        type: Object,
        required: true,
      },
    },
  
    data: () => ({ 
      show: true     
    }),

    methods: {
      closeModal() {
        this.show = false;
        this.$emit('close');
      },
      
      deleteFunctionality() {
        PerfisService
          .removeFunctionality(this.item.profile.id, this.item.functionality.id)
          .subscribe(() => {
            this.$emit('close');
            this.$emit('deleted');
          });
      }
    }
  }
</script>